export enum ECourierSignType {
  SignUp = "SignUp",

  SignIn = "SignIn",
}
